<template>
    <textarea
        :rows="rows"
        class="code-textarea"
        autocomplete="off"
        autocorrect="off"
        autocapitalize="off"
        spellcheck="false"
        :value="value"
        @input="fireInput"
        @keydown="handleCodeInputKeydown"
    ></textarea>
</template>

<script>
    export default {
        name: 'CodeTextarea',
        props: {
            rows: {
                default: 5,
                required: false,
            },
            value: {
                required: false,
            },
        },
        data () {
            return {
                //
            }
        },
        components: {
            //
        },
        computed: {
            //
        },
        mounted() {
            //
        },
        methods: {
            /**
             * Propogate the input event back to the parent
             *
             * @param  {Object} event
             * @return {void}
             */
            fireInput(event) {
                this.$emit('input', event)
            },
            /**
             * Retrieve the cursor location
             *
             * @param  {Object} element
             * @return {Number}
             */
            getCursorLocation(element) {
                if ('selectionStart' in event.target) {
                    return event.target.selectionStart
                } else if ('selection' in document) {
                    event.target.focus()
                    let selection = document.selection.createRange()
                    let selectionLength = document.selection.createRange().text.length
                    selection.moveStart('character', -event.target.value.length)

                    return selection.text.length - selectionLength
                }
            },
            /**
             * Handle a keypress event inside a code input field
             *
             * @param  {Object} event
             * @return {void}
             */
            handleCodeInputKeydown(event) {
                // [Tab]
                if (event.which === 9) {
                    event.preventDefault()

                    let pos = this.getCursorLocation(event.target)
                    let origValue = event.target.value

                    event.target.value = origValue.substring(0, pos)
                    event.target.value += '    '
                    event.target.value += origValue.substring(pos, origValue.length)

                    event.target.selectionStart = event.target.selectionEnd = pos + 4
                }

                // [Return]
                if (event.which === 13) {
                    event.preventDefault()

                    let pos = this.getCursorLocation(event.target)
                    var newPos = pos
                    let origValue = event.target.value

                    let lastChar = origValue.substr(pos - 1, 1)

                    let lastLine = origValue.substr(0, pos).split("\n").pop()
                    let trimmedLength = lastLine.trimStart().length
                    let prefix = lastLine.length - trimmedLength

                    event.target.value = origValue.substring(0, pos)
                    event.target.value += "\n" + ' '.repeat(prefix)
                    newPos += (1 + prefix)

                    if (lastChar === '{') {
                        event.target.value += '    '
                        newPos += 4
                    }

                    event.target.value += origValue.substring(pos, origValue.length)

                    event.target.selectionStart = event.target.selectionEnd = newPos
                }
            },
        },
    }
</script>

<style lang="less" scoped>
.code-textarea {
    font-size: 14px;
    background: #333333;
    color: #FFFFFF;
    font-family: Monaco, Courier, monospace;
}
</style>
